import '@aytm/app/stats/primereact/index'

import { mountPreloader, preloaderRepalette, unmountPreloader } from '@aytm/app/stats/preloader'
import { mountTooltips } from '@aytm/app/stats/components/tooltip'

// Mounted from the existing stats entry rather than its own pack: a new
// entrypoint is missing from the compiled manifest until webpack is rebuilt,
// which takes the whole page down rather than just the loading state.
const startPreloader = () => {
  mountPreloader()
  // Answers every mark on the report that declares a tooltip, so the page draws
  // its own rather than leaving the browser to draw one in its chrome.
  mountTooltips()
}
if ('loading' === document.readyState) document.addEventListener('DOMContentLoaded', startPreloader)
else startPreloader()

window.statsPreloader = {
  mount: mountPreloader,
  unmount: unmountPreloader,
  repalette: preloaderRepalette
}

import '../src/webpack-options'
export * from '@aytm/app/stats/page/export'
